import { regex } from 'vuelidate/lib/validators/common'

const orderIdRegEx = /(\d{8})-(\d+)/

export default regex('orderid', orderIdRegEx)
